const initialState = {
  data: [],
  total: 0,
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_USERS':
      return {
        ...state,
        data: action.payload.users,
        total: action.payload.users.length,
      }
    default:
      return state
  }
}

export default DataTablesReducer
